<script>
import Modal from '../../../components/Modal.vue'
import { debounce } from 'lodash'
import VueSelect from 'vue-select'

export default {
    components: {
        Modal,
        VueSelect,
    },

    props: {
        jobApplication: {
            type: Object,
            required: true
        },
        csrfToken: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            currentUrl: window.location.href
        }
    },
    watch: {
        selectedMessage(value, oldValue) {
            this.currentUrl = window.location.href
        }
    },
    methods: {
        toggleModal() {
            this.$refs.modal.toggle()
        }
    }
}
</script>

<template>
    <modal ref="modal" heading="Recruiter Notes">
        <h4>Create notes for {{ jobApplication.user.full_name }}</h4>

        <form method="POST"
            action="/recruiter/active-requisitions/recruiter-notes">
            <input type="hidden" name="_csrfToken" :value="csrfToken" />
            <input type="hidden" name="job_application_id" :value="jobApplication.id" />
            <input type="hidden" name="redirect_url" :value="currentUrl" />

            <div class="mb-4">
                <label>Notes</label>
                <br/>
                <textarea class="quick-message" v-model="jobApplication.recruiter_notes" name="recruiter_notes" rows="12"></textarea>
            </div>

            <div class="grid-x grid-padding-x align-right">
                <div class="cell shrink">
                    <button class="button" :disabled="(jobApplication.recruiter_notes === '')" type="submit">Save Notes</button>
                </div>

                <div class="cell shrink">
                    <button @click="toggleModal" class="button warning" type="button">Close</button>
                </div>
            </div>
        </form>
    </modal>
</template>

<style>
select {
    height: 4rem;
}

.quick-message {
    background: white !important;
    border-radius: 5px !important;
    border: 1px solid #D1D1D1 !important;
    margin-bottom: 0 !important;
    height: 100% !important;
    opacity: 1 !important;
}
</style>
